import { apiClient } from "../client";
import { API_ENDPOINTS } from "../endpoints";
import type {
  Mode,
  ModesResponse,
  CreateModeRequest,
  UpdateModeRequest,
} from "@/types/api.types";

export const modesService = {
  /**
   * Get all modes (admin - includes inactive)
   */
  getAllModes: async (): Promise<ModesResponse> => {
    return await apiClient.get(API_ENDPOINTS.MODES.ADMIN_ALL);
  },

  /**
   * Get mode by slug
   */
  getModeBySlug: async (slug: string): Promise<Mode> => {
    return await apiClient.get(API_ENDPOINTS.MODES.DETAIL(slug));
  },

  /**
   * Create new mode
   */
  createMode: async (data: CreateModeRequest): Promise<Mode> => {
    return await apiClient.post(API_ENDPOINTS.MODES.CREATE, data);
  },

  /**
   * Update mode
   */
  updateMode: async (id: number, data: UpdateModeRequest): Promise<Mode> => {
    return await apiClient.put(API_ENDPOINTS.MODES.UPDATE(id), data);
  },

  /**
   * Upload mode logo
   */
  uploadLogo: async (
    file: File,
  ): Promise<{ url: string; filename: string }> => {
    const formData = new FormData();
    formData.append("logo", file);

    return await apiClient.post(API_ENDPOINTS.MODES.UPLOAD_LOGO, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /**
   * Toggle mode active/inactive
   */
  toggleMode: async (
    id: number,
  ): Promise<{ id: number; isActive: boolean; message: string }> => {
    return await apiClient.patch(API_ENDPOINTS.MODES.TOGGLE(id));
  },

  /**
   * Delete mode
   */
  deleteMode: async (id: number): Promise<{ message: string }> => {
    return await apiClient.delete(API_ENDPOINTS.MODES.DELETE(id));
  },

  /**
   * Reorder modes
   */
  reorderModes: async (
    orders: { id: number; order: number }[],
  ): Promise<{ message: string }> => {
    return await apiClient.patch(API_ENDPOINTS.MODES.REORDER, { orders });
  },
};
